var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDragNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 12.5a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zM5.333 7.167a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.334 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zM5.333 1.833a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667z",
    fill: "#171717"
  })));
}

export default SvgDragNew;